class BeforeAfterSlider extends HTMLElement {
  connectedCallback() {
    this._after  = this.querySelector('.ws-ba-slider__img--after');
    this._handle = this.querySelector('.ws-ba-slider__handle');
    this._grip   = this.querySelector('.ws-ba-slider__grip');
    this._pos    = 50;
    this._setPos(50);

    this.addEventListener('mousedown',  this._start.bind(this));
    this.addEventListener('touchstart', this._start.bind(this), { passive: true });

    this._handle.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft')  this._setPos(Math.max(2,  this._pos - step));
      if (e.key === 'ArrowRight') this._setPos(Math.min(98, this._pos + step));
    });

    // Animate left→right when first scrolled into view
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this._hinted) {
            this._hinted = true;
            io.disconnect();
            this._playHint();
          }
        });
      }, { threshold: 0.5 });
      io.observe(this);
    }
  }

  _playHint() {
    // Slide left then right then back to centre, with smooth transitions
    const steps  = [50, 22, 78, 50];
    const delays = [350, 700, 1250, 1800];

    const enableTransition = () => {
      this._handle.style.transition = 'left .42s ease';
      if (this._after) this._after.style.transition = 'clip-path .42s ease';
    };
    const clearTransition = () => {
      this._handle.style.transition = '';
      if (this._after) this._after.style.transition = '';
    };

    enableTransition();

    steps.forEach((pct, i) => {
      setTimeout(() => {
        this._setPos(pct);
        if (i === steps.length - 1) setTimeout(clearTransition, 450);
      }, delays[i]);
    });

    // Pulse the grip to draw the eye
    if (this._grip) {
      setTimeout(() => {
        this._grip.classList.add('ws-ba-slider__grip--hint');
        this._grip.addEventListener('animationend', () => {
          this._grip.classList.remove('ws-ba-slider__grip--hint');
        }, { once: true });
      }, 200);
    }
  }

  _start(e) {
    // Kill any in-progress hint animation
    this._handle.style.transition = '';
    if (this._after) this._after.style.transition = '';

    this._dragging = true;
    const move = this._move.bind(this);
    const end  = () => {
      this._dragging = false;
      window.removeEventListener('mousemove', move);
      window.removeEventListener('touchmove', move);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup',  end, { once: true });
    window.addEventListener('touchend', end, { once: true });
    this._move(e);
  }

  _move(e) {
    if (!this._dragging) return;
    const rect = this.getBoundingClientRect();
    const x    = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    this._setPos(Math.max(2, Math.min(98, (x / rect.width) * 100)));
  }

  _setPos(pct) {
    this._pos = pct;
    this.style.setProperty('--ws-ba-pos', pct + '%');
    if (this._handle) this._handle.setAttribute('aria-valuenow', Math.round(pct));
  }
}

if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', BeforeAfterSlider);
}
